// extracted by mini-css-extract-plugin
export default {"container":"ActivityLogProductTab_container__TD4sT","noData":"ActivityLogProductTab_noData__J5Etd"};